import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthenticationGuard } from "@bndes/bndes-ux4/bn-seguranca";
import { EscolhaModalidadeGuard } from "src/app/interceptors/escolha-modalidade.guard";
import { DominiosResolver } from "src/app/shared/resolvers/dominios.resolver";
import { NaturezasJuridicasAceitasPesquisaComponent } from "./pesquisa/naturezas-juridicas-aceitas-pesquisa.component"

const routes: Routes = [
  {
    path: 'consulta-de-naturezas-juridicas-aceitas',
    canActivate: [AuthenticationGuard, EscolhaModalidadeGuard],
    data: { canReuse: false },

    children: [
      {
        path: 'pesquisa',
        component: NaturezasJuridicasAceitasPesquisaComponent,
        resolve: {
          dominios: DominiosResolver
        },
      },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class NaturezasJuridicasAceitasRoutingModule { }
